module.exports = __webpack_public_path__ + "static/img/s17.7fa8d33d.png";